module.exports = __webpack_public_path__ + "static/img/B_07_2.3202890.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/baggage/B_07_2.jpg
// module id = gBHh
// module chunks = 0